import config from '../config.json';
import axios from 'axios';

export class FileService {
    constructor(){
    }

    upload = async (entity, entityId, property, base64) => {
        return (await axios.post(`${config.BASE_URL}files/upload`,{ entity, entityId, property, base64 })).data;
    }

    listByEntity = async (entity, entityId) => {
        return (await axios.get(`${config.BASE_URL}files/${entity}/${entityId}`)).data;
    }
    
    listAll = async (ids) => {
        return (await axios.get(`${config.BASE_URL}files?ids=${ids.join(",")}`)).data;
    }
}